import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('use_csr_for_supported_nin_fields');
	},
};
